import { Button, Col, Grid, Row } from "antd";
import type { FC } from "react";
import responsiveColumn from "../../../../methods/responsiveColumn";
import Image from "next/image";
import { useTranslation } from "next-i18next";
import Link from "next/link";

export const ComplianceSection6: FC = () => {
  const { useBreakpoint } = Grid;
  const screenSize = useBreakpoint();
  const { t } = useTranslation("compliance");

  return (
    <Row
      justify={"center"}
      style={{
        padding: "50px 0",
        lineHeight: 1.5,
      }}
    >
      <Col {...responsiveColumn([17, 23, 24, 24, 24, 24])}>
        <h2
          className='section_title'
          style={{ fontSize: screenSize.md ? 48 : 24, textAlign: "center" }}
        >
          {t("section6_title")}
        </h2>
        <Row gutter={[50, 50]} justify={"center"}>
          <Col
            {...responsiveColumn([13, 11, 10, 22, 22, 22], [1, 1, 1, 2, 2, 2])}
            style={{ lineHeight: 1.5 }}
          >
            <div style={{ textAlign: "left" }}>
              <p
                style={{
                  fontSize: 16,
                  lineHeight: "24px",
                }}
              >
                {t("section6_p1_1")}
                <b>{t("section6_p1_b1")}</b>
                {t("section6_p1_2")}
                <b>{t("section6_p1_b2")}</b>
                {t("section6_p1_3")}
              </p>
              <p
                style={{
                  marginTop: screenSize.md ? 10 : 20,
                  fontSize: 16,
                  lineHeight: "24px",
                }}
              >
                {t("section6_p2_1")}
                <b>{t("section6_p2_b1")}</b>
                {t("section6_p2_2")}
              </p>
              <p
                style={{
                  marginTop: screenSize.md ? 10 : 20,
                  fontSize: 16,
                  lineHeight: "24px",
                }}
              >
                {t("section6_p3_1")}
                <b>{t("section6_p3_b1")}</b>
                {t("section6_p3_2")}
              </p>
              <p
                style={{
                  marginTop: screenSize.md ? 10 : 20,
                  fontSize: 16,
                  lineHeight: "24px",
                }}
              >
                {t("section6_p4_1")}
                <b>{t("section6_p4_b1")}</b>
                {t("section6_p4_2")}
              </p>
              <p
                style={{
                  marginTop: screenSize.md ? 10 : 20,
                  fontSize: 16,
                  lineHeight: "24px",
                }}
              ></p>
            </div>
          </Col>
          <Col
            {...responsiveColumn([9, 9, 10, 23, 23, 23], [2, 2, 2, 1, 1, 1])}
            className='flexCenter'
          >
            <Image
              src='/Tax_Compliance_Group_Tax_Services.jpg'
              width={425}
              height={408}
              alt='woman'
              className='imageResponsive'
            />
          </Col>
        </Row>
        <Row justify={"center"}>
          <Col
            {...responsiveColumn([21, 21, 21, 22, 22, 22])}
            style={{ textAlign: "center" }}
          >
            <Link
              href='/tax-compliance/state-and-local-tax-compliance-services'
              style={{ display: "inline-block" }}
            >
              <Button
                type='primary'
                size='large'
                style={{
                  marginTop: screenSize.lg ? 20 : 0,
                  fontSize: 15,
                  paddingLeft: 20,
                  paddingRight: 20,
                  // height: "clamp(65px, 4vw, 68px)",
                  height: screenSize.lg ? "auto" : "100%",
                  whiteSpace: "normal",
                }}
              >
                <span>{t("section6_button")}</span>
              </Button>
            </Link>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
